/**
 *
 *  GymBadge -- used in Location Selector
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 31/10/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback } from "react";
import PropTypes from "prop-types";

export const GymBadge = ({
  className,
  active,
  withAddress,
  element: Element = "div",
  gym,
  onClick,
}) => {
  const handleClick = useCallback(() => {
    onClick && onClick(gym);
  }, [gym, onClick]);

  return (
    <Element
      className={`${
        className ? `${className} ` : ""
      }tbk-min-w-0 tbk-flex tbk-h-4 tbk-items-center tbk-whitespace-nowrap tbk-rounded-lg tbk-border tbk-px-1 tbk-py-0.5 ${
        active
          ? "tbk-border-main-grey tbk-bg-basic-white"
          : "tbk-border-blue-grey-light tbk-bg-grey-light hover:tbk-border-grey-main hover:tbk-bg-basic-white"
      } tbk-text-primary`}
      onClick={handleClick}
    >
      <span className="tbk-text-secondary tbk-overflow-hidden tbk-text-ellipsis">
        {gym.name}
        {withAddress ? ` (${gym.address})` : ""}
      </span>
    </Element>
  );
};

GymBadge.propTypes = {
  gym: PropTypes.shape({
    value: PropTypes.string,
    name: PropTypes.string,
    placeId: PropTypes.string,
    partnerId: PropTypes.number,
    address: PropTypes.string,
    detail: PropTypes.string,
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
};

export default GymBadge;
